import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry";

/**
 * Base
 */
// Debug
const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * axes
 */

/*const axesHelper = new THREE.AxesHelper()
scene.add(axesHelper)*/
/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTextrue = textureLoader.load('textures/matcaps/8.png')

/**
 * Material
 */
const material = new THREE.MeshMatcapMaterial()
material.matcap = matcapTextrue

/**
 * FONTS
 */
let text = `first line. \n second line. \n third line.`
const fontLoader = new FontLoader()
fontLoader.load(
  'fonts/helvetiker_regular.typeface.json',
  (font) => {
    const textGeometry = new TextGeometry(
      'DONUTS.\nfrom outer \nspace.',
      {
        font: font,
        size: 0.5,
        height: 0.2,
        curveSegments: 2,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 2
      }
    )
    textGeometry.center()
    const text = new THREE.Mesh(textGeometry, material)
    scene.add(text)
  },
  () => {
    console.log('loading')
  },
  (error) => {
    console.log(error)
  }
)


/**
 * Object Donut
 */
const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
let donutsArray = []

console.time('donuts')

for (let i = 0; i < 300; i++) {

  const donut = new THREE.Mesh(donutGeometry, material)

  donut.rotation.x = Math.random() * Math.PI
  donut.rotation.z = Math.random() * Math.PI

  const scale = Math.random()
  donut.scale.set(scale, scale, scale)

  donut.userData = {
    posY: THREE.MathUtils.randFloat(-10, 10),			// at what height
    radius: THREE.MathUtils.randFloat(5, 10),			// how far from Y-axis
    phase: Math.random() * Math.PI * 2,						// where to start
    speed: (0.1 - Math.random() * 0.2) * Math.PI	// how fast to circulate
  }
  donutsArray.push(donut)
  scene.add(donut)
}

console.timeEnd('donuts')


/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 5
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
  const elapsedTime = clock.getElapsedTime()

  donutsArray.forEach(d => {
    let ud = d.userData;
    let a = (ud.speed * elapsedTime) + ud.phase;
    d.position.set(Math.cos(a), 0, -Math.sin(a))
      .multiplyScalar(ud.radius)
      .setY(ud.posY);
    d.rotation.y = (0.1 - Math.random() * 0.2) * Math.PI

  })
  // Update controls
  controls.update()

  // Render
  renderer.render(scene, camera)

  // Call tick again on the next frame
  window.requestAnimationFrame(tick)
}

tick()
